// FUNÇÕES/MÓDULOS SITE
import megaMenu from './modules/Layouts/menu'
import wppVisibility from './modules/Layouts/footer'
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import AnimationElements  from './modules/Animation/enterElements'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import bootstrapForms from './modules/Forms/bootstrapForms'
import changeLang from './modules/Utils/changeLang'

changeLang();
megaMenu();
wppVisibility();
//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
bootstrapForms();

// Animations
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()
